import { Comment } from './Comment'
import { withComment } from './withComment'

const ConnectedComment = withComment(Comment)

export { ConnectedComment as Comment }
